import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import useMobileMediaQuery from '@/hooks/useMobileMediaQuery'

export const BehaviorDetectionSheet = () => {
  const { t } = useTranslation()
  const data = [
    {
      name: t('setup.behaviorDetection.flags.threats'),
      description: t('setup.behaviorDetection.flags.threatsDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.violence'),
      description: t('setup.behaviorDetection.flags.violenceDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.weapon'),
      description: t('setup.behaviorDetection.flags.weaponDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.harassment'),
      description: t('setup.behaviorDetection.flags.harassmentDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.prejudice'),
      description: t('setup.behaviorDetection.flags.prejudiceDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.disparaging'),
      description: t('setup.behaviorDetection.flags.disparagingDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.selfHarm'),
      description: t('setup.behaviorDetection.flags.selfHarmDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.suggestiveContent'),
      description: t(
        'setup.behaviorDetection.flags.suggestiveContentDescription',
      ),
    },
    {
      name: t('setup.behaviorDetection.flags.fraud'),
      description: t('setup.behaviorDetection.flags.fraudDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.profanity'),
      description: t('setup.behaviorDetection.flags.profanityDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.polarizingContent'),
      description: t(
        'setup.behaviorDetection.flags.polarizingContentDescription',
      ),
    },
    {
      name: t('setup.behaviorDetection.flags.drugs'),
      description: t('setup.behaviorDetection.flags.drugsDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.nudity'),
      description: t('setup.behaviorDetection.flags.nudityDescription'),
    },
    {
      name: t('setup.behaviorDetection.flags.alcohol'),
      description: t('setup.behaviorDetection.flags.alcoholDescription'),
    },
  ]
  const isMobile = useMobileMediaQuery()
  return (
    <Sheet>
      <SheetTrigger>
        <p className="text-dynamicBlue text-left text-base font-normal text-nowrap">
          {t('setup.behaviorDetection.learnMore')}
        </p>
      </SheetTrigger>

      <SheetContent
        className="flex flex-col gap-8 max-h-full overflow-y-auto rounded-tl-2xl px-4"
        side={isMobile ? 'bottom' : 'right'}
      >
        <SheetHeader className="flex flex-col gap-3 mt-[-6px]">
          <SheetTitle className="text-textNormal text-xl font-medium tracking-wide text-left">
            {t('setup.behaviorDetection.sheetTitle')}
          </SheetTitle>
          <SheetDescription className="max-md:text-left">
            {t('setup.behaviorDetection.sheetDescription')}
          </SheetDescription>
        </SheetHeader>

        <div className="flex flex-col gap-8 justify-center ">
          {data?.map((Behavior, index) => {
            return (
              <div className="flex flex-col gap-3" key={index}>
                <p className="text-neutralColor text-base font-medium">
                  {Behavior?.name}
                </p>
                <p className="text-neutralColor60 text-sm font-medium tracking-tight">
                  {Behavior?.description}
                </p>
              </div>
            )
          })}
        </div>
      </SheetContent>
    </Sheet>
  )
}
